module.exports = __webpack_public_path__ + "static/img/preview-4.c86e763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/zombs/preview-4.png
// module id = Zoxd
// module chunks = 35